<template>
  <div class="container-fluid about-container box-container">
    <v-row class="main_header" style="margin-bottom: 0px">
      <v-card style="width: 100vw; margin-right: 125px">
        <v-card-title >
          <v-col class="pl-4 text-left" xs12 :cols="6" style="color: #1b3a57; margin-top: 10px" >{{ headerTitle }}</v-col >
        </v-card-title>
        <v-layout column>
          <v-col cols="12" style="overflow: auto" class="p-0">
            <v-data-table
              hover
              v-model="selected"
              :headers="headers"
              :items="table_data"
              item-value="id"
              class="elevation-1"
              disable-pagination
              :hide-default-footer="true"
              :style="{ 'font-size': '12px', color: '#68696e', 'font-weight': '400', }"
            >
            <template #bottom></template>
            </v-data-table>
          </v-col>
        </v-layout>
      </v-card>
      <v-card style="width: 100vw; margin-right: 125px" class="mt-0">
        <v-card-title>
          <v-actions style="margin-bottom: 28px">
            <v-btn class="ma-2" variant="flat"  color="primary" @click="rePropose">Re-propose</v-btn>
            <v-btn class="ma-2" variant="flat" color="green"  @click="sendApprovalRequest" >APPROVE </v-btn>
            <v-btn class="ma-2" variant="flat" color="red" @click="sendRejectRequest" >REJECT</v-btn >
          </v-actions>
        </v-card-title>
      </v-card>
      <!--  Success messeage popup -->
      <v-row justify="center">
        <v-dialog v-model="successpopup" persistent max-width="424px">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <v-spacer></v-spacer>
              <v-btn icon @click="successpopup = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="text-center">
              <span> {{ successmessage }}</span>
            </v-card-text>
            <v-card-actions center>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mb-3" @click="afterClickOkLoadData"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
          <v-dialog v-model="proposePopup" persistent max-width="400px">
              <v-card class="v-card-100">
              <v-card class="v-card-100">
                  <v-card-title class="d-flex">
                  <span>Re-Propose</span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="proposePopup = false">
                      <v-icon>mdi-close</v-icon>
                  </v-btn>
                  </v-card-title>
              </v-card>
              <v-card-text>
                  <v-container>
                  <v-row>
                      <v-text-field v-model="remarks" label="Enter Remarks" outlined class="ma-2"></v-text-field>
                  </v-row>
                  </v-container>
              </v-card-text>
              <v-card-actions center>
                  <v-spacer></v-spacer>
                  <v-btn small color="primary" class="mb-3" :disabled="!remarks" @click="SubmitRePropose">Submit</v-btn>   
                  <v-spacer></v-spacer>
              </v-card-actions>
              </v-card>
          </v-dialog>
      </v-row>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "approveStatus",
  data() {
    return {
      headerTitle:
        "Your approval is required. Click below links to proceed further",
      successpopup: false,
      successmessage: "",
      userId: "",
      userName: "",
      req_id: "",
      table_data: [],
      selected: [],
      headers: [
        { title: "Tag Number", key: "tag_number", width: "12%", align: "start", sortable: false, },
        { title: "Brand", key: "brand" },
        { title: "MRP(₹)", key: "mrp" },
        { title: "Description", key: "description" },
        { title: "Requested By", key: "requested_by" },
        { title: "Inward Date", key: "inventory_created_date" },
      ],
      url_type: "",
      proposePopup : false,
      remarks:'',
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.userId = urlParams.get("user_id");
    this.userName = urlParams.get("user_name");
    this.req_id = urlParams.get("id");
    this.url_type = urlParams.get("type");
    if (this.url_type == 1) {
      const url = `https://ruleengine-api.blubirch.com/api/v1/approval_requests/${this.req_id}`;
      axios
        .get(url)
        .then((response) => {
          if (response.data) {
            this.table_data = [response.data.details];
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    } else if (this.url_type == 2) {
      const url = `https://qa-ruleengine-k8s.blubirch.com/api/v1/approval_requests/${this.req_id}`;
      axios
        .get(url)
        .then((response) => {
          if (response.data) {
            this.table_data = [response.data.approval_request.details];
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    } else if (this.url_type == 3) {
      const url = `https://ruleengine.blubirch.com/api/v1/approval_requests/${this.req_id}`;
      axios
        .get(url)
        .then((response) => {
          if (response.data) {
            this.table_data = [response.data.details];
            this.loading = false;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    }
  },
  methods: {
    sendApprovalRequest() {
      if (this.url_type == 1) {
        const url = `https://ruleengine-api.blubirch.com/api/v1/approval_requests/${this.req_id}/approve_request`;
        const params = { user_id: this.userId, user_name: this.userName };
        axios
          .get(url, { params })
          .then((response) => {
            this.successmessage = response.data.message;
            this.successpopup = true;
            this.$toast.success(
              "Approval request sent successfully:",
              response.data,
            );
          })
          .catch((error) => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              this.successmessage = error.response.data.message;
              this.successpopup = true;
            } else {
              this.$toast.error("Error sending approval request", error);
            }
          });
      } else if (this.url_type == 2) {
        const url = `https://qa-ruleengine-k8s.blubirch.com/api/v1/approval_requests/${this.req_id}/approve_request`;
        const params = { user_id: this.userId, user_name: this.userName };
        axios
          .get(url, { params })
          .then((response) => {
            this.successmessage = response.data.message;
            this.successpopup = true;
            this.$toast.success(
              "Approval request sent successfully:",
              response.data,
            );
          })
          .catch((error) => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              this.successmessage = error.response.data.message;
              this.successpopup = true;
            } else {
              this.$toast.error("Error sending approval request", error);
            }
          });
      } else if (this.url_type == 3) {
        const url = `https://ruleengine.blubirch.com/api/v1/approval_requests/${this.req_id}/approve_request`;
        const params = { user_id: this.userId, user_name: this.userName };
        axios
          .get(url, { params })
          .then((response) => {
            this.successmessage = response.data.message;
            this.successpopup = true;
            this.$toast.success(
              "Approval request sent successfully:",
              response.data,
            );
          })
          .catch((error) => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              this.successmessage = error.response.data.message;
              this.successpopup = true;
            } else {
              this.$toast.error("Error sending approval request", error);
            }
          });
      }
    },
    sendRejectRequest() {
      if (this.url_type == 1) {
        const url = `https://ruleengine-api.blubirch.com/api/v1/approval_requests/${this.req_id}/reject_request`;
        const params = { user_id: this.userId, user_name: this.userName };
        axios
          .get(url, { params })
          .then((response) => {
            this.successmessage = response.data.message;
            this.successpopup = true;
            this.$toast.success(
              "Rejection request sent successfully",
              response.data,
            );
          })
          .catch((error) => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              this.successmessage = error.response.data.message;
              this.successpopup = true;
            } else {
              this.$toast.error("Error sending approval request", error);
            }
          });
      } else if (this.url_type == 2) {
        const url = `https://qa-ruleengine-k8s.blubirch.com/api/v1/approval_requests/${this.req_id}/reject_request`;
        const params = { user_id: this.userId, user_name: this.userName };

        axios
          .get(url, { params })
          .then((response) => {
            this.successmessage = response.data.message;
            this.successpopup = true;
            this.$toast.success(
              "Rejection request sent successfully",
              response.data,
            );
          })
          .catch((error) => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              this.successmessage = error.response.data.message;
              this.successpopup = true;
            } else {
              this.$toast.error("Error sending approval request", error);
            }
          });
      } else if (this.url_type == 3) {
        const url = `https://ruleengine.blubirch.com/api/v1/approval_requests/${this.req_id}/reject_request`;
        const params = { user_id: this.userId, user_name: this.userName };

        axios
          .get(url, { params })
          .then((response) => {
            this.successmessage = response.data.message;
            this.successpopup = true;
            this.$toast.success(
              "Rejection request sent successfully",
              response.data,
            );
          })
          .catch((error) => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              this.successmessage = error.response.data.message;
              this.successpopup = true;
            } else {
              this.$toast.error("Error sending approval request", error);
            }
          });
      }
    },
    afterClickOkLoadData() {
      this.successpopup = false;
      this.proposePopup = false;
      // window.location.href = 'about:blank';
    },
    SubmitRePropose(){
      const url = `https://qa-ruleengine-k8s.blubirch.com/api/v1/approval_requests/${this.req_id}/repropose_request`;
      const data = { user_name: this.userName, remarks: this.remarks };    
      axios.put(url, data)
      .then(response => {
          this.successpopup = true
          this.successmessage = response.data.message
      })
      .catch(error => {
          if(error.response && error.response.data && error.response.data.message){
              this.successmessage = error.response.data.message;
              this.successpopup = true;
          }else {
          this.$toast.error('Error sending approval request', error);
          }
      });
    },
    rePropose(){
      this.proposePopup = true
    },
  },
};
</script>
<style scoped>
.text-start {
  color: #68696e;
  font-size: 12px;
}
</style>
